import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-000d0061"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = { class: "text-primary font-semibold" }
const _hoisted_3 = {
  key: 1,
  class: "text-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createBlock(_component_Breadcrumb, {
    home: _ctx.breadCrumbsHome,
    model: _ctx.breadCrumbsItems
  }, {
    item: _withCtx(({ item, props }) => [
      (item?.route && item?.level != _ctx.breadCrumbsLevel)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: item?.route,
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", _mergeProps({ href: href }, props?.action, { onClick: navigate }), [
                _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
              ], 16, _hoisted_1)
            ]),
            _: 2
          }, 1032, ["to"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
    ]),
    _: 1
  }, 8, ["home", "model"]))
}